export const foreignKeyMapping = {
  contacts: "contact_id",
  partners: "contact_id",
};
